<template>
    <div>
        <div class="col-12 justify-content-end col-md-4 mb-1 col-lg-4 d-flex align-items-center">
        	<p class="text-uppercase" :style="'margin-top:10px'" >Per page</p>
            <multiselect v-model="per_page" :options="[10, 20, 50, 100]" @select="setPerPageUpdate"
                :allow-empty="false" :show-labels="false"></multiselect>
            <button type="button" class="button" @click="exportCSV">Export CSV</button>
        </div>
        <table class="table table-bordered">
            <thead>
                <tr>
                    <th class="green-content"  v-for="(item, key) in table_headers" :key="key">{{item}}</th>
                </tr>
            </thead>
            <tbody v-if="dropZoneTable != undefined"> 
                <tr v-for="(item, key) in table_data" :key="key">
                    <td v-for="(opt,index) in dataOptions" :key="index">{{item[opt] || 'Fail'}}</td>
                </tr>
            </tbody>
            <tbody v-if="dropZoneTable == undefined" > 
                <tr v-for="(item, key) in table_data" :key="key">
                    <td v-for="(opt,index) in dataOptions" :key="index">{{item[opt]}}</td>
                </tr>
            </tbody>
        </table>
        <div class="row" v-if="dropZoneTable == undefined">
				<div class="col-12 col-lg-6">
					Total Records of {{history.length}}
				</div><!--col-->
                <div class="col-12 col-lg-6">
                    <b-pagination align="right" :total-rows="history.length" :value="currentPage" :per-page="parseInt(per_page)" @change="setPageUpdate">
                    </b-pagination>
                </div><!--col-->
		</div>
        <div class="row" v-if="dropZoneTable != undefined">
                <div class="col-12 col-lg-6">
                    Total Record of {{ dropZoneTable.rows }}
                </div>
                <div class="col-12 col-lg-6">
                    <b-pagination align="right" :total-rows="dropZoneTable.rows" v-model="dropZoneTable.currentPage" :per-page="parseInt(dropZoneTable.perPage)" @change="setPageUpdate">
                    </b-pagination>
                </div>
        </div>
    </div>
    
</template>
<script>
export default {
    props:['history','dropZoneTable','table_headers', 'dataOptions','update_result','update_result_fails','csv_data'],
    data : function(){
        return{
            current_page:1,
            per_page:10,
            tableData:'',
            data_to_export:''

        }

    },
    created : function(){
        if(this.dropZoneTable == undefined){
            this.loadTable()
        }else{
            this.loadTableDropZone()
        }
       
    },
    computed:{
        currentPage: function(){
            return this.current_page
        },
        table_data: function(){
            return this.tableData
        }

    },
    methods : {
        setPageUpdate : function(page){
            if(this.dropZoneTable == '' || this.dropZoneTable == undefined){
                 this.current_page = page
                 this.loadTable();
            }else{
                this.loadDataShow();
            }
           
            

        },
        setPerPageUpdate(page){
            if(this.dropZoneTable == '' || this.dropZoneTable == undefined){
                this.per_page = page
                this.loadTable();
            }else{
                this.dropZoneTable.currentPage = 1
                this.dropZoneTable.perPage = page
                this.loadDataShow();
            }
        },
        loadTable(){
            setTimeout(() =>{
                   this.tableData = this.history.slice((this.current_page-1)* this.per_page,
                     this.current_page * this.per_page)

            },500)
        },
        loadTableDropZone(){
            setTimeout(()=>{
                this.tableData = this.history
            },500)
            
        },
        loadDataShow: function(){
			// to check we what to load on data
			this.tableData = []
			if(this.dropZoneTable.failure != true){
				this.tableData = 
				this.update_result.slice((this.dropZoneTable.currentPage-1) * this.dropZoneTable.perPage, this.dropZoneTable.currentPage * this.dropZoneTable.perPage );
				this.dropZoneTable.rows = this.update_result.length;
			}
			else{
				//shows fails
				this.tableData = this.update_result_fails.slice((this.dropZoneTable.currentPage-1) * this.dropZoneTable.perPage, this.dropZoneTable.currentPage * this.dropZoneTable.perPage );
				//update current rows
				this.dropZoneTable.rows = this.update_result_fails.length;
			}
		},
        exportCSV(){
            // now we have filtered data -> previews
            this.data_to_export = ''
            if(this.dropZoneTable == undefined || this.dropZoneTable == ''){
                 this.data_to_export = this.history
            }else{
                // check we print only failures or not
                if(this.dropZoneTable.failure == true){
                    this.data_to_export = this.update_result_fails
                }else{
                    this.data_to_export = this.csv_data
                }
            }
           let csvContent = "data:text/csv;charset=utf-8,";
                csvContent += [
                    Object.keys(this.data_to_export[0]).join(","),
                ...this.data_to_export.map(item => Object.values(item).join(","))
                ]
                .join("\n")
                .replace(/(^\[)|(\]$)/gm, "");

                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", "export.csv");
                link.click();

            }
    }
  
}
</script>



// WEBPACK FOOTER //
// src/components/shared/profile/TableView.vue